import clsx from 'clsx';
import LabelledIcon from 'components/atoms/LabelledIcon/LabelledIcon';
import { NavLink } from 'components/molecules/NavLinks/mobiNavLinks';
import React from 'react';
import classes from './NavLinks.module.scss';
import { useRouter } from 'next/router';

export interface Props {
  navLinkArr: NavLink[];
  className?: string;
  borderPosition?: 'top' | 'bottom';
  isFooterNav?: boolean;
}

const NavLinks: React.FC<Props> = ({
  navLinkArr,
  borderPosition,
  isFooterNav,
  className,
}: Props) => {
  return (
    <div className={classes.navWrapper}>
      <nav role="navigation" className={clsx(classes.root, className)}>
        {navLinkArr?.map((navItem) => {
          return (
            <LabelledIcon
              key={navItem.id}
              id={navItem.id}
              borderPosition={borderPosition}
              label={navItem.label}
              href={navItem.href}
              className={classes.navLink}
              isFooterNavIcon={isFooterNav}
            >
              {navItem.icon}
            </LabelledIcon>
          );
        })}
      </nav>
    </div>
  );
};

export default NavLinks;
